// extracted by mini-css-extract-plugin
module.exports = {"imageFrame":"ImageProtection_imageFrame___jcTI","imageOverlay":"ImageProtection_imageOverlay__aFk_a"};